module.exports = __webpack_public_path__ + "assets/images/open-new.svg";